<div class="preview-overlay" (click)="close()">
  <!-- Main top bar -->
  <div class="top-bar" (click)="$event.stopPropagation()">
    <div class="top-bar__section left">
      <span class="file-title" *ngIf="currentFile">{{
        currentFile.originalname
        }}</span>
    </div>
    <div class="top-bar__section right">
      <a [href]="storageBaseUrl + currentFile._id" download [title]="currentFile.originalname" class="download-button">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
          <path
            d="M480-320 280-520l56-56 104 104v-328h80v328l104-104 56 56-200 200ZM240-160q-33 0-56.5-23.5T160-240v-160h80v160h480v-160h80v160q0 33-23.5 56.5T720-160H240Z" />
        </svg>
      </a>
      <button class="close-btn" (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
          <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Main content preview -->
  <div class="preview-content" (click)="$event.stopPropagation()">


    <div *ngIf="isLoading" class="row-center loading-indicator"> <span class="loader"></span></div>


    <img *ngIf="!isLoading && isImage" [src]="fileUrl" [alt]="currentFile.originalname" />
    <ngx-extended-pdf-viewer *ngIf="!isLoading && isPdf" [src]="pdfSrc" [showToolbar]="false" [zoom]="'page-width'"
      [pageViewMode]="'multiple'" [handTool]="true" [textLayer]="false" [backgroundColor]="'transparent'">
    </ngx-extended-pdf-viewer>
    <div *ngIf="!isLoading && isDocx" class="word-preview-container">
      <div class="doc-html-preview page-layout" [innerHTML]="docHtml"
        (click)="$event.preventDefault(); $event.stopPropagation()"></div>
    </div>
    <div *ngIf="!isLoading && isXlsx" class="doc-html-preview excel-preview">
      <table class="excel-table">
        <colgroup>
          <col *ngFor="let width of excelColumnWidths" [style.width.px]="width" />
        </colgroup>
        <tbody>
          <tr *ngFor="let row of excelProcessedData; let i = index" [style.height.px]="excelRowHeights[i]">
            <td *ngFor="let cell of row" [innerHTML]="cell.value" [style]="cell.style"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <pre *ngIf="!isLoading && isTxt" class="txt-preview">{{ txtContent }}</pre>

    <!-- Unsupported file message -->
    <div *ngIf="!isLoading && isUnsupported" class="unsupported-preview">
      <span>Vista previa no disponible.</span>
      <a [href]="storageBaseUrl + currentFile._id" download [title]="currentFile.originalname" class="download-link">
        Descargar aquí
      </a>
    </div>
  </div>

  <!-- Horizontal gallery of files -->
  <div #galleryScroller class="gallery-scroller" (click)="$event.stopPropagation()">
    <div class="gallery-items">
      <div #galleryItem *ngFor="let file of files" class="gallery-item-container" (click)="selectFile(file)"
        [class.selected]="file._id === currentFile?._id">
        <div class="thumbnail-container" [ngClass]="{ 'thumbnail--file': getType(file.originalname) !== 'image' }"
          [title]="file.originalname">
          <img *ngIf="getType(file.originalname) === 'image'" [src]="storageBaseUrl + file.thumbnail" />
          <img *ngIf="getType(file.originalname) === 'pdf'" src="assets/icons/pdf.svg" class="placeholder-icon" />
          <img *ngIf="getType(file.originalname) === 'docx'" src="assets/icons/docx.svg" class="placeholder-icon" />
          <img *ngIf="getType(file.originalname) === 'csv'" src="assets/icons/csv.svg" class="placeholder-icon" />
          <img *ngIf="getType(file.originalname) === 'xlsx'" src="assets/icons/xlsx.svg" class="placeholder-icon" />
          <img *ngIf="getType(file.originalname) === 'txt'" src="assets/icons/txt.svg" class="placeholder-icon" />
          <img *ngIf="getType(file.originalname) === 'email'" src="assets/icons/outlook.svg" class="placeholder-icon" />
        </div>
        <div class="file-info">
          <span class="caption" [title]="file.originalname">
            {{
            file.originalname && file.originalname.length > 16
            ? file.originalname.slice(0, 16) +
            '...' +
            file.originalname.split('.').pop()
            : file.originalname
            }}
          </span>
          <a [href]="storageBaseUrl + file._id" download class="download-icon"
            [title]="'Descargar ' + file.originalname" (click)="$event.stopPropagation()">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
              <path
                d="M480-320 280-520l56-56 104 104v-328h80v328l104-104 56 56-200 200ZM240-160q-33 0-56.5-23.5T160-240v-160h80v160h480v-160h80v160q0 33-23.5 56.5T720-160H240Z" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>